/**
 * @ngdoc service
 * @name manager-base.framework.common.services.Analytics
 *
 * @depends $window
 *
 * @description
 *
 * A service to handle logging errors to Heap
 *
 */

export function AnalyticsService(
    $window
) {
    const service = {};
    
    service.trackInHeap = function trackInHeap(eventName, eventData) {
        if ($window.heap && typeof $window.heap.track === 'function') {
            $window.heap.track(eventName, eventData);
        }
    };

    return service;
}
AnalyticsService.$inject = [
    '$window'
];
